export default "__VITE_ASSET__87cc936f__"